import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Text from '../../fields/Text';
import { useSelector } from 'react-redux';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import LoadingBars from '../../elements/LoadingBars';

export default function SubUserEditPriceForm({ handleSubmit, handleClose, isLoading }) {
  const { values } = useSelector((state) => state.form.formSetPasswordFile);

  const onSubmit = async (e) => {
    e.preventDefault();
    handleSubmit(values);
  };
  return (
    <form onSubmit={onSubmit}>
      <Field
        component={Text}
        inputProps={{
          label: 'Harga Jual Minimum Per Tabung',
          placeholder: 'Harga Jual Minimum Per Tabung',
        }}
        name="minPrice"
      />
      <Field
        component={Text}
        inputProps={{
          label: 'Harga Jual Maksimum Per Tabung',
          placeholder: 'Harga Jual Maksimum Per Tabung',
        }}
        name="maxPrice"
      />
      <div className={styles.containerBtn}>
        <Button onClick={handleClose} style={'outlined'} type={'button'}>
          Batal
        </Button>
        <Button
          disabled={!values.minPrice || !values.maxPrice || isLoading}
          style={'blue'}
          type={'submit'}
        >
          {isLoading && <LoadingBars size={1} />}
          Simpan
        </Button>
      </div>
    </form>
  );
}

SubUserEditPriceForm.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};
